﻿import { Directive } from "@app/components/directive";
import { IExpanderGroupController } from "@app/components/kb-expander/kb-expander-group.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IExpanderScope extends ng.IScope{
    expanded?: boolean;
    expandedChanged?: any;
    invalid?: boolean;
    icon?: string;
    image?: string;
    _toggle: () => void;
    element: ng.IAugmentedJQuery;
    _hasError: () => boolean;
}
interface IExpanderController {
    scope: IExpanderScope;
}

@NgComponent({
    token: Token.KbExpander,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbExpander extends Directive {
    constructor(
        $timeout: ng.ITimeoutService
    ) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-expander");
        this.transclude = {
            "title": "?kbExpanderTitle",
            "body": "kbExpanderBody"
        };
        this.scope = {
            expanded: "=?",
            expandedChanged: "&",
            invalid: "=?",
            icon: "@",
            image: "@"
        };
        this.replace = false;
        this.require = ["?^^kbExpanderGroup", "?^^kbExpander"];

        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            function (
                $scope: IExpanderScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes) {
                this.scope = $scope;
                $scope.element = $element;
            }];

        this.link = (scope: IExpanderScope, element, atts, controllers: any[]) => {
            let kbExpanderGroup: IExpanderGroupController = controllers[0];
            let parentExpander: IExpanderController = controllers[1];

            if (kbExpanderGroup && parentExpander) {
                if ($(parentExpander.scope.element).parents().length > $(kbExpanderGroup.scope.element).parents().length) {
                    // if the parent expander is closer to this element than the group then we need to ignore the group
                    kbExpanderGroup = undefined;
                }
            }

            if (kbExpanderGroup) kbExpanderGroup.registerExpander(scope);
            scope._toggle = () => {
                scope.expanded = !scope.expanded;
            }
            scope._hasError = () => {
                return element.find(".kb-field__error").length > 0;
            }
            scope.$watch("expanded", (newVal, oldVal) => {
                // Animate after transcluding to prevent the body being shown on load.
                element.find(".kb-expander__body").addClass("kb-animate");
                if (newVal != oldVal) {
                    if (kbExpanderGroup && scope.expanded) kbExpanderGroup.expand(scope);
                    if (scope.expandedChanged) scope.expandedChanged();
                }
            });
        };
    }
}
